<template>
  <BoxedFrame title="Notes">
    <section>
      <Form
        :form-id="NOTE_FORM_ID"
        :initial-values="{ note }"
        :class="{ dirty }"
        class="section"
      >
        <VPRichText
          input-id="note"
          placeholder="Add notes"
          :menu-item-compact-config="menuItemCompactConfig"
          :menu-item-full-config="menuItemCompactConfig"
          @update:model-value="onNoteInput"
        />
      </Form>
    </section>
  </BoxedFrame>
</template>
<script setup lang="ts">
import BoxedFrame from '@/components/BoxedFrame.vue';
import VPRichText from '@/components/form/VPRichText.vue';
import { computed } from 'vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { NOTE_FORM_ID } from '@/stores/offer-sheet-form';
import { Form, useFormsStore, RichTextMenuItemEnum } from 'vuniform';
import { debounce } from 'debounce';

const formsStore = useFormsStore();
const offerSheetStore = useOfferSheetStore();

const note = computed(() => offerSheetStore.offerSheet?.note);

const loading = computed(() => offerSheetStore.offerSheetLoading);
const offerSheet = computed(() => offerSheetStore.offerSheet);

const menuItemCompactConfig = [
  { type: RichTextMenuItemEnum.BOLD },
  { type: RichTextMenuItemEnum.ITALIC },
  { type: RichTextMenuItemEnum.ORDERED_LIST },
  { type: RichTextMenuItemEnum.DIVIDER },
  { type: RichTextMenuItemEnum.CLEAR_FORMAT },
  { type: RichTextMenuItemEnum.UNDO },
  { type: RichTextMenuItemEnum.REDO },
];

const onNoteSave = () => {
  if (loading.value || !formsStore.isFieldDirty(NOTE_FORM_ID, 'note')) {
    return;
  }

  let v = formsStore.fieldGetValue(NOTE_FORM_ID, 'note');

  v = v == '<p></p>' ? '' : v;

  offerSheetStore.updateOfferSheet({
    id: offerSheetStore.offerSheet.id,
    note: v,
  });

  formsStore.SET_INITIAL_VALUES({
    values: { ...offerSheet.value },
    formId: NOTE_FORM_ID,
    clearDirty: true,
  });
};

const onNoteInput = debounce(onNoteSave, 500);

interface Props {
  formId: string;
  placeholder?: string;
  initialValues: unknown;
}

defineProps<Props>();
</script>
